import React from 'react'
import * as S from './styles'
const AnimaBalde = () => {
  return (
    <svg
      width="220"
      height="92"
      viewBox="0 0 296 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <S.AnimatedPath
        delay={1}
        d="M10.2393 83.2081C22.5665 90.4604 42.5333 90.4604 54.8605 83.2081C67.1877 75.9559 67.1715 64.2266 54.8605 56.9744C42.5496 49.7221 22.5503 49.7221 10.2393 56.9744C-2.07166 64.2266 -2.08788 75.9724 10.2393 83.2081Z"
        fill="#833D90"
      />
      <S.AnimatedPath
        delay={1.5}
        d="M112.49 91.3686C144.121 91.3686 169.763 76.2876 169.763 57.6843C169.763 39.081 144.121 24 112.49 24C80.8592 24 55.2173 39.081 55.2173 57.6843C55.2173 76.2876 80.8592 91.3686 112.49 91.3686Z"
        fill="#833D90"
      />
      <S.AnimatedPath
        delay={2}
        d="M213.817 91.3686C245.447 91.3686 271.089 76.2876 271.089 57.6843C271.089 39.081 245.447 24 213.817 24C182.186 24 156.544 39.081 156.544 57.6843C156.544 76.2876 182.186 91.3686 213.817 91.3686Z"
        fill="#833D90"
      />
      <S.AnimatedPath
        delay={2.5}
        d="M278.534 75.3779C280.72 76.5096 283.138 77.0995 285.59 77.0995C288.042 77.0995 290.46 76.5096 292.646 75.3779C296.555 73.0816 296.555 69.3646 292.646 67.1179C290.459 65.9901 288.042 65.4023 285.59 65.4023C283.139 65.4023 280.721 65.9901 278.534 67.1179C274.642 69.3316 274.642 73.0486 278.534 75.3779Z"
        fill="#833D90"
      />

      <S.AnimatedPath
        delay={0}
        d="M59.9561 15.9339L7.24105 15.207L6.7869 59.0511C6.7869 63.0159 9.28477 67.0138 14.3941 70.0865C24.6127 76.265 41.3031 76.4467 51.7001 70.4995C56.9229 67.5094 59.5343 63.528 59.5343 59.5137L59.9561 15.9339Z"
        fill="#37474F"
      />
      <S.AnimatedPath
        delay={0}
        d="M15.0915 4.33733C4.72696 10.2845 4.62964 20.0974 14.8645 26.2593C25.0993 32.4213 41.7734 32.603 52.1705 26.6723C62.5675 20.7417 62.6324 10.9123 52.3975 4.75033C42.1627 -1.41163 25.4399 -1.60987 15.0915 4.33733Z"
        fill="#455A64"
      />
      <S.AnimatedPath
        delay={0}
        d="M57.6852 15.7531C57.6795 16.4744 57.5534 17.1894 57.3122 17.8676C56.1076 20.8449 53.8585 23.2593 51.0026 24.6408C45.5815 27.4746 39.5431 28.8614 33.4526 28.6717C27.3676 28.7277 21.3682 27.2101 16.0161 24.2609C13.245 22.8297 11.078 20.423 9.91735 17.4877C9.66626 16.7607 9.54006 15.9951 9.54429 15.2244C9.54429 11.9204 11.9449 8.79813 16.2269 6.38621C21.6233 3.51596 27.6607 2.12673 33.7445 2.35533C39.843 2.27164 45.8596 3.79084 51.2135 6.76619C55.4307 9.31027 57.7177 12.4821 57.6852 15.7531Z"
        fill="#263238"
      />
      <S.AnimatedPath
        delay={0}
        d="M57.3122 17.8668C56.1076 20.8441 53.8585 23.2584 51.0026 24.64C45.5815 27.4737 39.5432 28.8606 33.4526 28.6708C27.3676 28.7269 21.3682 27.2092 16.0161 24.26C13.245 22.8289 11.078 20.4222 9.91736 17.4868C11.1132 14.5078 13.3656 12.0958 16.2269 10.7302C21.6285 7.87115 27.6601 6.47189 33.7445 6.66625C39.8459 6.62706 45.8569 8.16755 51.2135 11.1432C53.9767 12.5609 56.143 14.9492 57.3122 17.8668Z"
        fill="#BA68C8"
      />

      <S.AnimatedPath
        delay={0}
        opacity="0.15"
        d="M51.0026 24.6404C51.8412 24.1499 52.6435 23.5978 53.4032 22.9884C43.7847 28.2583 27.2403 26.0445 22.0824 21.9145C16.9244 17.7845 16.2269 10.7305 24.6127 7.5752C21.6795 8.18181 18.8527 9.23436 16.2269 10.6975C13.3656 12.0632 11.1132 14.4751 9.91736 17.4542C11.078 20.3895 13.245 22.7962 16.0161 24.2274C21.3682 27.1766 27.3676 28.6942 33.4526 28.6382C39.5404 28.8381 45.5785 27.4627 51.0026 24.6404Z"
        fill="black"
      />
      <S.AnimatedPath
        delay={0}
        d="M44.839 32.3552C45.9906 31.6944 46.9152 32.2561 46.899 33.6107C46.8507 34.3422 46.6349 35.0519 46.2687 35.6831C45.9025 36.3142 45.3962 36.8492 44.7904 37.2451C43.6225 37.9224 42.698 37.3607 42.7142 36.0061C42.763 35.2706 42.9807 34.5571 43.3498 33.923C43.7189 33.2888 44.229 32.7518 44.839 32.3552Z"
        fill="#263238"
      />
      <S.AnimatedPath
        delay={0}
        d="M7.12753 22.9054C4.22415 28.7205 -1.53395 42.5643 5.94347 48.2141L6.86801 48.8584V51.6502C6.12189 51.1877 5.35955 50.659 4.61343 50.1139C-6.57837 41.6722 6.04078 19.9979 6.59226 19.0893C6.65784 18.9694 6.74606 18.8639 6.85184 18.7788C6.95762 18.6938 7.07887 18.6309 7.20862 18.5938L7.12753 22.9054Z"
        fill="#E0E0E0"
      />
      <S.AnimatedPath
        delay={0}
        d="M45.8122 35.3615C45.504 36.0223 37.3616 51.8815 23.9639 55.0698C22.4506 55.4447 20.8986 55.6333 19.3412 55.6315C14.8959 55.5423 10.5682 54.161 6.86801 51.6502V48.8583C12.399 52.757 17.9625 54.1117 23.4124 52.8231C35.7721 49.866 43.6874 34.4198 43.7523 34.2711C43.8939 33.9991 44.1348 33.7946 44.4231 33.7019C44.7114 33.6092 45.0239 33.6356 45.2932 33.7756C45.4352 33.8384 45.5626 33.931 45.6671 34.0473C45.7717 34.1636 45.851 34.301 45.9 34.4506C45.9489 34.6002 45.9664 34.7586 45.9513 34.9155C45.9362 35.0725 45.8888 35.2244 45.8122 35.3615Z"
        fill="#E0E0E0"
      />
    </svg>
  )
}
export default AnimaBalde
